class Storage {
    isLocalStorageSupported = false;

    constructor() {
        if (this.checkLocalStorageSupport()) {
            this.isLocalStorageSupported = true;
        }
    }

    checkLocalStorageSupport() {
        console.log('check local storage support')
        const test = 'testXYZ';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch(e) {
            return false;
        }
    }

    setItem(key, value) {
        if(!this.isLocalStorageSupported) return;
        console.log('storeage setItem=', key, value)
        localStorage.setItem(key, value);
    }

    getItem(key) {
        if(!this.isLocalStorageSupported) return;
        return localStorage.getItem(key);
    }

    clear() {
        if(!this.isLocalStorageSupported) return;
        localStorage.clear();
    }
}

export default new Storage()


// WEBPACK FOOTER //
// ./src/services/storage.js